<template>
  <div
    class="attribute-group form-group col-12"
    :class="attributeName"
  >
    <label>{{ label }}</label>
    <div
      class="product-attributes"
      :class="classes"
    >
      <Tooltip
        v-for="attributeValue in attributes[attributeName].attribute_values"
        :text="getAttributeTooltipText(language, product, attributeValue)"
        :class="[
          `attribute-${attributeValue.id}`,
          {
            sold: soldProductWithAttribute(product, attributeValue.id),
          },
        ]"
      >
        <div
          class="attribute"
          :class="{
            active:
              product.attribute_values[attributeName].id === attributeValue.id,
          }"
          @click="updateProductAttributeValue(attributeName, attributeValue)"
        >
          <!-- Image -->
          <div
            v-if="optional(attributeValue.preferences)[imageAttribute]"
            class="image"
            :style="{
              backgroundImage: `url(${attributeValue.preferences[imageAttribute]})`,
            }"
          />
          <!-- Color -->
          <div
            v-if="optional(attributeValue.preferences).color"
            class="color"
            :style="{ backgroundColor: attributeValue.preferences.color }"
          />

          <p
            class="sold-text"
            v-html="$t('Sold')"
          />
        </div>
      </Tooltip>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { optional, formattedPrice, capitalize } from '../../../../../helpers'
import useProduct from '../../useProduct'
import Tooltip from '../../../../packages/views/tooltip/Tooltip'

export default {
  components: {
    Tooltip,
  },
  props: {
    classes: {
      type: String,
      default: () => '',
    },
    label: {
      type: String,
    },
    isRequired: {
      type: Boolean,
    },
    attributeName: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      product: 'product/getProduct',
      attributes: 'product/getAttributes',
      language: 'language/getCurrentLanguage',
    }),
    imageAttribute() {
      return `${this.language.domain}ImageUrl`
    },
  },
  setup(props) {
    const {
      updateProductAttributeValue,
      soldProductWithAttribute,
      getAttributeTooltipText,
    } = useProduct()

    return {
      updateProductAttributeValue,
      optional,
      soldProductWithAttribute,
      capitalize,
      getAttributeTooltipText,
    }
  },
}
</script>
